<template>
	<div class="basic-form">
		<div class="basic-form__direction" ref="originatorRequired">
			<MultiselectGroup
				:isWeb="isWeb"
				:label="'Empresa - Originador: *'"
				:type="'originator'"
				:options="originatorsOptions"
				:placeholder="'Nome do Originador'"
				:alert="requiredFields.originatorId"
				ref="originator"
				@changeMultiselectInput="changeMultiselectInput"
			/>
			<MultiselectGroup
				:isWeb="isWeb"
				:label="'Estruturador: *'"
				:type="'structurer'"
				:options="structurersOptions"
				:placeholder="'Nome do Estruturador'"
				:alert="requiredFields.structurerId"
				ref="structurer"
				@changeMultiselectInput="changeMultiselectInput"
			/>
		</div>
		<div class="basic-form__direction" ref="shortDescription">
			<InputGroup
				title="Nome: *"
				:customClass="'textarea'"
				:id="'short_description'"
				:placeholder="'Mensagem'"
				:alertClass="requiredFields.shortDescription ? 'alert' : ''"
				v-model="offer.shortDescription"
			/>
			<small class="basic-form__field--input--required" v-if="requiredFields.shortDescription"
				>Campo obrigatório.</small
			>
		</div>
		<div class="basic-form__direction">
			<InputGroup
				:title="'Descrição:'"
				:customClass="'textarea'"
				:id="'description'"
				:placeholder="'Mensagem'"
				:maxLength="189"
				:isTextArea="true"
				v-model="offer.description"
			/>
		</div>
		<div class="basic-form__direction">
			<InputGroup
				:title="'Descrição Longa:'"
				:customClass="'textarea long'"
				:id="'long_description'"
				:placeholder="'Mensagem'"
				:isTextArea="true"
				v-model="offer.longDescription"
			/>
		</div>
		<div class="basic-form__direction">
			<InputGroup
				:title="'Metodologia:'"
				:customClass="'textarea'"
				:id="'description'"
				:placeholder="'Mensagem'"
				:isTextArea="true"
				v-model="offer.methodology"
			/>
		</div>
		<div class="basic-form__direction" ref="industryRequired">
			<MultiselectGroup
				:isWeb="isWeb"
				:label="'Indústria: *'"
				:type="'industry'"
				:options="industriesOptions"
				:placeholder="'Selecionar Indústria'"
				:alert="requiredFields.industryTypeId"
				ref="industry"
				@changeMultiselectInput="changeMultiselectInput"
			/>
			<MultiselectGroup
				:isWeb="isWeb"
				:label="'Tipo de Operação: *'"
				:type="'operation_type'"
				:options="operationsOptions"
				:placeholder="'Selecionar Operação'"
				:alert="requiredFields.operationTypeId"
				ref="operation_type"
				@changeMultiselectInput="changeMultiselectInput"
			/>
			<MultiselectGroup
				:isWeb="isWeb"
				:label="'Status: *'"
				:type="'status'"
				:options="statusOptions"
				:placeholder="'Selecionar Status'"
				:alert="requiredFields.offerStatusId"
				ref="status"
				@changeMultiselectInput="changeMultiselectInput"
			/>
		</div>
		<div class="basic-form__direction">
			<InputGroup
				:title="'Garantias:'"
				:id="'garanties'"
				:placeholder="'Inserir Garantias'"
				v-model="offer.garanties"
			/>
			<InputGroup
				:title="'Subordinação:'"
				:id="'subordination'"
				:placeholder="'Inserir Subordinado'"
				v-model="offer.subordination"
			/>
		</div>
		<div class="basic-form__direction" ref="indexerRequired">
			<MultiselectGroup
				:isWeb="isWeb"
				:label="'Indexador: *'"
				:type="'indexer'"
				:options="indexersOptions"
				:placeholder="'CDI'"
				:alert="requiredFields.indexerId"
				:small="true"
				ref="indexer"
				@changeMultiselectInput="changeMultiselectInput"
			/>
			<InputGroup
				:title="'Yield:'"
				:id="'yield'"
				:placeholder="'Inserir Yield'"
				v-model="offer.yield"
			/>
			<InputGroup
				:title="'Rendimento:'"
				:id="'string_value'"
				:placeholder="'Rendimento'"
				v-model="offer.profitability"
			/>
			<InputGroup
				:title="'Rendimento Mínimo:'"
				:id="'min_value'"
				:placeholder="'Rendimento Mínimo'"
				v-mask="['#', '#,#', '#,##', '##,##']"
				v-model="offer.profitabilityMin"
			/>
			<InputGroup
				:title="'Rendimento Máximo:'"
				:id="'max_value'"
				:placeholder="'Rendimento Máximo'"
				v-mask="['#', '#,#', '#,##', '##,##']"
				v-model="offer.profitabilityMax"
			/>
		</div>
		<div class="basic-form__direction">
			<InputGroup
				:title="'Valor:'"
				:id="'offer_value'"
				:placeholder="'Inserir Valor'"
				:ref="'offer_value'"
				:isMoney="true"
			/>
			<InputGroup
				:title="'Prazo Total:'"
				:id="'total'"
				:placeholder="'Inserir Prazo'"
				v-model="offer.issueDate"
			/>
		</div>
		<div class="basic-form__direction">
			<InputGroup
				:title="'Data de Bookbuilding:'"
				:id="'bookbuilding'"
				:placeholder="'__/__/__'"
				:isMasked="'##/##/####'"
				v-model="offer.saleOffEstimatedDate"
			/>
			<InputGroup
				:title="'Data de Emissão:'"
				:id="'emission'"
				:placeholder="'__/__/__'"
				:isMasked="'##/##/####'"
				v-model="offer.endOffEstimatedDate"
			/>
			<InputGroup
				:title="'Código do Ativo:'"
				:id="'code'"
				:placeholder="'Inserir Código'"
				v-model="offer.assetCode"
			/>
			<InputGroup
				:title="'Série:'"
				:id="'serie'"
				:placeholder="'Inserir Número de Série'"
				v-model="offer.serie"
			/>
		</div>
		<div class="basic-form__direction" v-show="false">
			<InputGroup
				:title="'Alocação Total:'"
				:id="'total_alocation'"
				:placeholder="'Inserir Alocação Total'"
				v-model="offer.allocationsTotal"
			/>
			<InputGroup
				:title="'Alocação Consumido:'"
				:id="'total_cons'"
				:placeholder="'Inserir Alocação Consumido'"
				v-model="offer.allocationsUsed"
			/>
			<InputGroup
				:title="'Slot Total:'"
				:id="'slot_total'"
				:placeholder="'Inserir Slot Total'"
				v-model="offer.slotsTotal"
			/>
			<InputGroup
				:title="'Slot Consumido:'"
				:id="'slot_cons'"
				:placeholder="'Inserir Slot Consumido'"
				v-model="offer.slotsUsed"
			/>
		</div>
		<div class="basic-form__direction">
			<InputGroup
				:title="'Valor Reservado:'"
				:id="'value_reserved'"
				:ref="'value_reserved'"
				:placeholder="'Inserir Valor Reservado'"
				:isMoney="true"
			/>
			<InputGroup
				:title="'Valor da Demanda (finalizado):'"
				:id="'value_demand'"
				:ref="'value_demand'"
				:placeholder="'Inserir Valor da Demanda (finalizado)'"
				:isMoney="true"
			/>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { mask } from 'vue-the-mask';
import InputGroup from '@/components/modules/Offer/OfferDetail/InputGroup/InputGroup.vue';
import MultiselectGroup from '@/components/modules/Offer/OfferDetail/MultiselectGroup/MultiselectGroup.vue';
import { scrollToRequiredElement } from '@/utils/scrollToRequiredElement';
import OfferStatusEnum from '@/enums/OfferStatusEnum';

export default {
	name: 'OfferBasicForm',
	directives: { mask },
	components: {
		InputGroup,
		MultiselectGroup,
	},
	props: {
		isWeb: {
			required: true,
		},
		newOffer: {
			required: true,
		},
	},
	data: () => ({
		offer: {
			originatorId: null,
			operationTypeId: null,
			industryTypeId: null,
			description: null,
			shortDescription: null,
			longDescription: null,
			methodology: null,
			indexerId: null,
			profitability: null,
			profitabilityMin: null,
			profitabilityMax: null,
			totalValue: 0,
			totalReserved: 0,
			endOffEstimatedDate: null,
			saleOffEstimatedDate: null,
			slotsTotal: null,
			slotsUsed: null,
			allocationsTotal: null,
			allocationsUsed: null,
			assetCode: null,
			serie: null,
			subordination: null,
			garanties: null,
			offerStatusId: null,
			structurerId: null,
			demandValue: null,
			yield: null,
			issueDate: null,
		},
		cloneOffer: false,
		offerStatusIdBefore: null,
		requiredFields: {
			originatorId: false,
			operationTypeId: false,
			industryTypeId: false,
			indexerId: false,
			structurerId: false,
			offerStatusId: false,
			shortDescription: false,
		},
	}),
	watch: {
		offerOriginators() {
			if (this.$route.query.originator) {
				this.preSelectOriginator();
			}
		},
	},
	methods: {
		getStatusName(status) {
			const { name } = this.statusOptions.find((option) => option.id === status);
			return name;
		},
		validateFields() {
			const requiredProps = [
				'originatorId',
				'operationTypeId',
				'industryTypeId',
				'indexerId',
				'structurerId',
				'offerStatusId',
				'shortDescription',
			];

			let ref;
			this.requiredFields = requiredProps.reduce((acc, prop) => {
				acc[prop] = !this.offer[prop];

				if (acc.indexerId) {
					ref = 'indexerRequired';
				}

				if (acc.operationTypeId || acc.industryTypeId || acc.offerStatusId) {
					ref = 'industryRequired';
				}

				if (acc.originatorId || acc.structurerId) {
					ref = 'originatorRequired';
				}

				if (acc.shortDescription) {
					ref = 'shortDescription';
				}

				return acc;
			}, {});

			const hasMissingFields = requiredProps.some((prop) => !this.offer[prop]);

			if (hasMissingFields) {
				return scrollToRequiredElement(this, ref);
			}

			const offersStatusToNotify = [OfferStatusEnum.PILOT_FISHING, OfferStatusEnum.ROADSHOW];
			const selectedStatusIsEqualBefore =
				offersStatusToNotify.includes(this.offerStatusIdBefore) &&
				this.offer.offerStatusId === this.offerStatusIdBefore;

			if (selectedStatusIsEqualBefore || this.offer.offerStatusId === OfferStatusEnum.FINISHED) {
				const statusName = this.getStatusName(this.offer.offerStatusId);
				return this.$emit('handleModal', statusName);
			}

			if (this.newOffer || this.cloneOffer) {
				this.$emit('createOffer');
			} else {
				this.$emit('updateOffer');
			}
		},
		getMoneyValues() {
			this.offer.totalValue = this.$refs.offer_value.getMoneyValue();
			this.offer.totalReserved = this.$refs.value_reserved.getMoneyValue();
			this.offer.demandValue = this.$refs.value_demand.getMoneyValue();
		},
		getOfferData() {
			this.getMoneyValues();
			return this.offer;
		},
		loadOfferDetails(selectedOffer) {
			this.setOfferDetails(selectedOffer);
			this.loadMultiselectInputs(selectedOffer);
			this.loadMoneyInputs(selectedOffer);
			this.loadDatesInputs(selectedOffer);
		},
		setOfferDetails(selectedOffer) {
			const {
				originator: { id: originatorId },
				operationType: { id: operationTypeId },
				industryType: { id: industryTypeId },
				indexer: { id: indexerId },
				offerStatus: { id: offerStatusId },
				structurer: { id: structurerId },
				description,
				shortDescription,
				longDescription,
				methodology,
				profitability,
				profitabilityMin,
				profitabilityMax,
				slotsTotal,
				slotsUsed,
				allocationsTotal,
				allocationsUsed,
				assetCode,
				serie,
				subordination,
				garanties,
				yield: offerYield,
				issueDate,
			} = selectedOffer;

			Object.assign(this.offer, {
				originatorId,
				operationTypeId,
				industryTypeId,
				indexerId,
				offerStatusId,
				structurerId,
				description,
				shortDescription,
				longDescription,
				methodology,
				profitability,
				profitabilityMin,
				profitabilityMax,
				slotsTotal,
				slotsUsed,
				allocationsTotal,
				allocationsUsed,
				assetCode,
				serie,
				subordination,
				garanties,
				issueDate,
			});
			this.cloneOffer = this.$route.query.action === 'clone';
			this.offer.shortDescription = this.cloneOffer
				? `Copy de ${shortDescription}`
				: shortDescription;
			this.offer.offerStatusId = this.cloneOffer ? null : offerStatusId;
			this.offerStatusIdBefore = this.offer.offerStatusId;
			this.offer.yield = offerYield;
		},
		loadMoneyInputs(selectedOffer) {
			this.$refs.offer_value.setMoneyValue(
				selectedOffer.totalValue == null ? 0 : selectedOffer.totalValue,
			);
			this.$refs.value_reserved.setMoneyValue(
				selectedOffer.totalReserved == null ? 0 : selectedOffer.totalReserved,
			);
			this.$refs.value_demand.setMoneyValue(
				selectedOffer.demandValue == null ? 0 : selectedOffer.demandValue,
			);

			const { totalValue, totalReserved, demandValue } = selectedOffer;

			Object.assign(this.offer, {
				totalValue,
				totalReserved,
				demandValue,
			});
		},
		loadMultiselectInputs(selectedOffer) {
			const cloneOffer = this.$route.query.action;
			this.$refs.originator.setValue(selectedOffer.originator);
			this.$refs.operation_type.setValue(selectedOffer.operationType);
			this.$refs.industry.setValue(selectedOffer.industryType);
			this.$refs.indexer.setValue(selectedOffer.indexer);
			this.$refs.status.setValue(cloneOffer ? null : selectedOffer.offerStatus);
			this.$refs.structurer.setValue(selectedOffer.structurer);
		},
		loadDatesInputs(selectedOffer) {
			this.offer.endOffEstimatedDate = this.$moment(
				selectedOffer.endOffEstimatedDate,
				'YYYY-MM-DD',
			).format('DD/MM/YYYY');

			this.offer.saleOffEstimatedDate = this.$moment(
				selectedOffer.saleOffEstimatedDate,
				'YYYY-MM-DD',
			).format('DD/MM/YYYY');
		},
		changeMultiselectInput(param) {
			const typeMapping = {
				originator: ['originatorId', 'originatorId'],
				structurer: ['structurerId', 'structurerId'],
				industry: ['industryTypeId', 'industryTypeId'],
				operation_type: ['operationTypeId', 'operationTypeId'],
				status: ['offerStatusId', 'offerStatusId'],
				indexer: ['indexerId', 'indexerId'],
			};

			const [offerProp, requiredFieldProp] = typeMapping[param.type] || [];

			if (offerProp) {
				this.offer[offerProp] = param.value?.id || param.value;
				if (requiredFieldProp) {
					this.requiredFields[requiredFieldProp] = false;
				}
			}
		},
		preSelectOriginator() {
			let routeOriginator = this.offerOriginators.filter(
				(originator) => originator.id == this.$route.query.originator,
			);
			this.$refs.originator.setValue({
				id: routeOriginator[0].id,
				name: routeOriginator[0].name,
			});
			this.offer.originatorId = routeOriginator[0].id;
		},
	},
	computed: {
		...mapGetters('offerManagement', [
			'offerOriginators',
			'offerIndustries',
			'offerOperations',
			'offerStatus',
			'offerIndexers',
			'offerStructurers',
		]),
		...mapGetters('investor', ['investorList']),
		originatorsOptions() {
			return this.offerOriginators.length ? this.offerOriginators : [];
		},
		industriesOptions() {
			return this.offerIndustries.industryTypes != undefined &&
				this.offerIndustries.industryTypes.length
				? this.offerIndustries.industryTypes
				: [];
		},
		operationsOptions() {
			return this.offerOperations != undefined && this.offerOperations.length
				? this.offerOperations
				: [];
		},
		statusOptions() {
			return this.offerStatus.offerStatus != undefined && this.offerStatus.offerStatus.length
				? this.offerStatus.offerStatus
				: [];
		},
		indexersOptions() {
			return this.offerIndexers != undefined && this.offerIndexers.length ? this.offerIndexers : [];
		},
		structurersOptions() {
			return this.offerStructurers != undefined && this.offerStructurers.length
				? this.offerStructurers
				: [];
		},
	},
};
</script>

<style lang="scss" scoped>
@import 'OfferBasicForm.scss';
</style>
